import React from "react"
import getVideoId from "get-video-id"
import getDiff from "../helpers/helpers"
import { Link } from "gatsby"
import { LazyLoadComponent } from "react-lazy-load-image-component"

const TutoCard = ({ tuto }) => {
  const thumbUrl = `https://img.youtube.com/vi/${
    getVideoId(tuto.meta.tablature_lienTutoYoutube).id
  }/hqdefault.jpg`
  const tutoLink = `/tablature/${tuto.slug}`
  // const diffClass = `tuto-diff-${getDiff(tuto)}`

  // const getDiff = (tuto) => {
  //   switch (tuto.difficulty) {
  //     case "Très Facile": return 1
  //     case "Facile": return 2
  //     case "Moyen": return 3
  //     case "Difficile": return 4
  //     case "Très Difficile": return 5
  //     default: return 1
  //   }
  // }
  // console.log(`Tuto`, tuto);
  return (
    <div className="col-sm-6 col-md-4 ">
      <Link to={tutoLink} className="tuto-stretched-link">
        <div className={`single-tuto tuto-diff-${getDiff(tuto.difficulty)}`}>
          <LazyLoadComponent>
            <div
              className="tuto-image"
              style={{ backgroundImage: "url(" + thumbUrl + ")" }}
            />
          </LazyLoadComponent>
          <div className="tuto-meta">
            <div
              className="tuto-meta-title"
              dangerouslySetInnerHTML={{ __html: tuto.title }}
            />
            <div
              className="tuto-meta-artist"
              dangerouslySetInnerHTML={{ __html: tuto.artist }}
            />
            <div className="tuto-meta-style">
              <div dangerouslySetInnerHTML={{ __html: tuto.style }} />
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}
export default TutoCard
